import { render, staticRenderFns } from "./ChangeDetectionResult.vue?vue&type=template&id=321d27b9"
import script from "./ChangeDetectionResult.vue?vue&type=script&lang=js"
export * from "./ChangeDetectionResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports